import { defineStore } from 'pinia'
import axios from 'axios'

export const useProjectStore = defineStore('projectStore', {
  state: () => ({
    projects: [],
    project: {},
    filters: {},
    sortOrder: ''
  }),
  getters: {
    getQueryString (state) {
      return new URLSearchParams(state.filters).toString()
    },
    getProjectParticipants (state) {
      if (!state.project.participants) return []
      return state.project.participants.map(p => p.id)
    }
  },
  actions: {
    async updateFilters (prop, value, search = true) {
      if (value === null) {
        delete this.filters[prop]
      } else {
        this.filters[prop] = value
      }
      if (search !== false) {
        await this.loadProjects()
      }
    },
    async setFilters (filters = {}, search = true) {
      this.filters = filters
      if (search !== false) {
        await this.loadProjects()
      }
    },
    async setSortOrder (prop, dir = 1, search = true) {
      this.sortOrder = `&sort[][${prop}]=${dir}`
      if (search !== false) {
        await this.loadProjects()
      }
    },
    setProject (project) {
      this.project = project
    },
    async loadProject (id) {
      const project = await axios.get(`/v2/projects/${id}`)
      this.project = project.data
    },
    async loadProjects () {
      const projects = await axios.get(`/v2/projects?` + new URLSearchParams(this.filters).toString() + '&' + this.sortOrder)
      this.projects = projects.data
    },
    async addProject (data) {
      await axios.post(`/v2/projects`, data)
    },
    async patchProject (id, data) {
      const project = await axios.patch(`/v2/projects/${id}`, data)
      this.project = project.data
    },
    async deleteProject (id) {
      await axios.delete(`/v2/projects/${id}`)
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/ProjectStore.js